// Caves of Qud color mappings from Display.txt
export const QUD_COLORS: Record<string, string> = {
  r: '#a64a2e', // dark red
  R: '#d74200', // red
  g: '#009403', // dark green
  G: '#00c420', // green
  b: '#0048bd', // dark blue
  B: '#0096ff', // blue
  c: '#40a4b9', // dark cyan
  C: '#77bfcf', // cyan
  m: '#b154cf', // dark magenta
  M: '#da5bd6', // magenta
  w: '#98875f', // brown
  W: '#cfc041', // yellow/gold
  k: '#0f3b3a', // dark black
  K: '#155352', // black
  y: '#b1c9c3', // gray
  Y: '#FFFFFF', // white
  o: '#f15f22', // dark orange
  O: '#e99f10', // orange
};

export function getColor(code: string): string {
  // Handle color strings like "&w" or just "w"
  const cleanCode = code.replace(/^&/, '');
  return QUD_COLORS[cleanCode] || '#FFFFFF';
}

export function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 255, g: 255, b: 255 };
}
